import React from "react";

interface IProps {
	src: string;
	keyword?: string;
	url?: string;
}

export default function DesktopBanner({ src, keyword, url }: IProps) {
	return (
		<div
			className={`bg-white shadow-sm rounded-sm p-1.5 ${keyword ? "cursor-pointer" : ""}`}
			onClick={() => keyword ? (window.location.href = url ?? `/search/${keyword}`) : null}
		>
			<img src={src} />
		</div>
	);
}
